import { render } from "./VehicleItemDesktop.vue?vue&type=template&id=b32418ba&scoped=true"
import script from "./VehicleItemDesktop.vue?vue&type=script&lang=js"
export * from "./VehicleItemDesktop.vue?vue&type=script&lang=js"

import "./VehicleItemDesktop.vue?vue&type=style&index=0&id=b32418ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32418ba"]])

export default __exports__